import { render, staticRenderFns } from "./JsonMessage.vue?vue&type=template&id=2b917e72&scoped=true"
import script from "./JsonMessage.vue?vue&type=script&lang=js"
export * from "./JsonMessage.vue?vue&type=script&lang=js"
import style0 from "./JsonMessage.vue?vue&type=style&index=0&id=2b917e72&prod&lang=scss&scoped=true"
import style1 from "./JsonMessage.vue?vue&type=style&index=1&id=2b917e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b917e72",
  null
  
)

export default component.exports